export const BLOG_PHILOSOPHY_URL =
  "https://sianko.pl/blog/czy-placic-za-obowiazki";

export type PhilosophyCardId = "hygiene" | "community" | "extra";

export type PhilosophyCard = {
  id: PhilosophyCardId;
  emoji: string;
  tag: string;
  title: string;
  body: string;
  pillCls: string;
  appHint: string;
};

export const PHILOSOPHY_CARDS: PhilosophyCard[] = [
  {
    id: "hygiene",
    emoji: "💚",
    tag: "Poza aplikacją",
    title: "Podstawowa higiena",
    body: "Mycie zębów, mycie rąk, ubieranie się, mycie się przed snem. To nie są obowiązki domowe — to bycie człowiekiem. W Sianko ich nie ma, bo nie wszystko trzeba mierzyć i nagradzać.",
    pillCls: "bg-green/15 text-forest",
    appHint: "Tych zadań w ogóle nie dodawaj do Sianko — aplikacja nie zastępuje rodzica w przypominaniu o szczotce.",
  },
  {
    id: "community",
    emoji: "💛",
    tag: "Niepłatne · XP",
    title: "Pomoc rodzinie",
    body: "Ścielenie łóżka, sprzątanie zabawek, pakowanie plecaka, rozładowywanie zmywarki, nakrywanie do stołu, segregacja śmieci. Drużynowa robota — wszyscy są na pokładzie, każdy ma swoją część. Dziecko dostaje XP, ale nie pieniądze.",
    pillCls: "bg-help/20 text-help",
    appHint: "W aplikacji: 💛 Pomoc rodzinie — bez stawki, dziecko dostaje XP.",
  },
  {
    id: "extra",
    emoji: "💰",
    tag: "Płatne (opcjonalnie)",
    title: "Zadania dodatkowe",
    body: "Mycie samochodu, koszenie trawy, mycie okien, archiwizacja zdjęć. Praca, która wykracza poza codzienny standard, oszczędza czas rodzicom albo robi się ją rzadko. Tu płacenie ma sens — uczy, że wysiłek przekłada się na konkretną wartość.",
    pillCls: "bg-gold/25 text-pending",
    appHint: "W aplikacji: 💰 Zadanie dodatkowe — ze stawką w PLN.",
  },
];
